import { render, staticRenderFns } from "./CreateLocations.vue?vue&type=template&id=530e3ca5"
import script from "./CreateLocations.vue?vue&type=script&lang=js"
export * from "./CreateLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports